import { modalTypes } from "./types";

const questions = [
  {
    blockName:
      "Как вы оцениваете уровень развития хирургии в лечебном учреждении вашего региона относительно мирового (московского?) – варианты от 1 до 10, где 1 – очень плохо, 10 – просто отлично и на уровне.",
    type: modalTypes.questionsOnScale,
    list: [
      {
        name: "",
        range: 10,
      }
    ],
  },
  {
    blockName:
      "Используете ли вы в своей хирургической практике национальные клинические рекомендации Минздрава РФ?",
    type: modalTypes.questionsChoiceOfOptionsOne,
    list: [
      { name: "Да", isChecked: false },
      {
        name: "Нет",
        isChecked: false,
      },
      { name: "Никогда", isChecked: false },

    ],
  },
  {
    blockName:
      "Что, на ваш взгляд, является самой насущной проблемой, мешающей развитию хирургии сегодня (в вашем регионе или вообще)",
    type: modalTypes.questionsChoiceOfOptionsOne,
    list: [
      {
        name: "проблемы в подготовке кадров",
        isChecked: false,
      },
      {
        name: "проблемы с оборудованием и инструментарием",
        isChecked: false,
      },
      {
        name: "недостаточный уровень зарплат врачей-хирургов",
        isChecked: false,
      },
      {
        name: "что-то иное?",
        isChecked: false,
        answer: ''
      },
    ],
  },
  {
    blockName: "Где вы работаете сейчас (город) и где видите себя через 10 лет",
    type: modalTypes.questionsChoiceOfOptionsOne,
    list: [
      { name: "останусь работать в своем городе", isChecked: false },
      {
        name: "планирую перебраться в Москву, Санкт-Петербург",
        isChecked: false,
      },
      { name: "переберусь в другой крупный город РФ", isChecked: false },
      { name: "планирую работать за границей", isChecked: false },
    ],
  },
];

export let questionsClone = structuredClone(questions);
